let _sendAuthHeader = true
let _env = process.env.REACT_APP_ENVIRONMENT;

//Example constans for firebase
let API_KEY = process.env.REACT_APP_API_KEY;
let APP_ID = process.env.REACT_APP_ID;
let GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
let AUTH_DOMAIN = process.env.REACT_APP_AUTH_DOMAIN;
let DATABASE_URL = process.env.REACT_APP_DATABASE_URL;
let STORAGE_BUCKET = process.env.REACT_APP_STORAGE_BUCKET;
let MESSAGING_SENDER_ID = process.env.REACT_APP_MESSAGING_SENDER_ID;
let PRODUCT_ID = process.env.REACT_APP_PRODUCT_ID
let MENU_URL_DOMAIN = process.env.REACT_APP_MENU_URL_DOMAIN
let DYNAMIC_LINK_DATA = {
  domainPrefix:process.env.REACT_APP_DYNAMIC_LINK_DOMAIN,
  androidPkg:process.env.REACT_APP_DYNAMIC_LINK_ANDROID,
  iosPkg:process.env.REACT_APP_DYNAMIC_LINK_IOS,
  linkDomain:process.env.REACT_APP_DYNAMIC_LINK_RESPONSE_DOMAIN
} 




//Example variable
const URL_PRODUCTS = 'products';
const DUMMY = 'dummy';

class Settings {
  static get env() {
    return _env
  }

  static set env(value) {
    _env = value
  }

  static get SERVICE_DOMAIN(){
    return process.env.REACT_APP_API_BASE;
  }

  static get API_KEY() { 
    return API_KEY;
  }
  static get APP_ID() { 
    return APP_ID;
  }
  static get GOOGLE_API_KEY(){
    return GOOGLE_API_KEY
  }
  static get AUTH_DOMAIN() { 
    return AUTH_DOMAIN;
  }
  static get DATABASE_URL() {
    return DATABASE_URL;
  }
  static get STORAGE_BUCKET() {
    return STORAGE_BUCKET;
  }
  static get MESSAGING_SENDER_ID() { 
    return MESSAGING_SENDER_ID;
  }

  static get PRODUCT_ID(){
    return PRODUCT_ID
  }

  static get MENU_URL_DOMAIN(){
    return MENU_URL_DOMAIN
  }

  static get DYNAMIC_LINK_DATA(){
    return DYNAMIC_LINK_DATA
  }

  static get sendAuthHeader() {
    return _sendAuthHeader
  }

  static set sendAuthHeader(value) {
    _sendAuthHeader = value
  }
  //Example getter
  static get productsEndpoint() {
    return URL_PRODUCTS
  }
}

module.exports = Settings



// WEBPACK FOOTER //
// ./src/provider/base/Settings.js